<!--首页 俱乐部/考级中心 入口-->
<template>
  <div class="gray-back" style="padding: 0.2rem 0.2rem 1rem 0.2rem; height: 100% ; text-align:center">
    <img v-rblink="{name:'ClubIndex2',query:{}}" src="https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230911/user-0/20230911/4c25394f002be36144d87ff7f8201216.png" />
    <img v-rblink="{name:'QcxjIndex2',query:{}}" src="https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230911/user-0/20230911/18fd0f829935a046bf9dbea5cee73d2e.png" />
  </div>
</template>
<style scoped>

.gray-back img{
  width: 100%;
  border-radius: 10px;
  box-shadow: #0000000d 0 0 10px;
}
.send-btn {
  width: 1.3rem;
  height: 38px;
  background: linear-gradient(
      90deg,
      rgba(254, 200, 53, 1) 0%,
      rgba(255, 173, 25, 1) 100%
  );
  border-radius: 4px;
  margin-left: 12px;
  line-height: 38px;
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}

.send-comment {
  width: 7.1rem;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
}

.comment-bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 1.08rem;
  background: rgba(247, 247, 247, 1);
  border: 1px solid rgba(236, 236, 236, 1);
}

.release-time-right {
  display: flex;
}

.icon-zan-comment-box {
  width: 175px;
  height: 38.5px;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 4px;
}

.activity-place {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(190, 190, 190, 1);
  margin-left: 5px;
}

.detail-header {
  height: 40px;
  padding: 10px 10px;
  background: #fff;
}

.row img {
  width: 100%;
}

.row2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0.2rem;
}

.row2-li {
  position: relative;
}

.row-tip {
  position: absolute;
  left: 50%;
  top: 6px;
  transform: translate(-50%, -50%); /* 50%为自身尺寸的一半 */
  -webkit-transform: translate(-50%, -50%);
  font-size: 10px;
}

.row2 img {
  height: 92px;
}

.row4 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0.2rem 0.2rem 0;
}

.row4 img {
  /*width: 100%;*/
  float: left;
  width: calc(25%);
  margin: 0 10px 10px 0;
}

.row4 img.current {
  box-shadow: 0px 0px 10px 0px rgba(119, 175, 255, 1);
}

.row5 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0.2rem;
  /*flex-wrap: wrap;*/
}

.row5 img {
  /*width: 100%;*/
  float: left;
  width: calc(33.33%);
  margin: 0 10px 10px 0;
}

.row5 img.current {
  box-shadow: 0px 0px 10px 0px rgba(119, 175, 255, 1);
}

.row2 div:last-child,
.row4 img:last-child,
.row5 img:last-child {
  margin-right: 0;
}

.dialog-head {
  font-size: 0.5rem;
  font-weight: 700;
  text-align: center;
  padding: 0.4rem 0 0.3rem;
}

.dialog-content {
  padding: 0 0.3rem;
  font-size: 14px;
}

.dialog-content >>> .van-button {
  line-height: 1.2;
  font-size: 14px;
}

.dialog-li {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dialog-step-li {
  margin: 0.2rem 0 0.4rem;
}

.bottom-button {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}
</style>
<script>
import Vue from "vue";
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from "@/components/picker/PicUploader.vue";
import LoginDialog from "@/components/LoginDialog.vue";
import NewsItem2 from "@/components/news/NewsItem2.vue";
import NewsItem3 from "@/components/news/NewsItem3.vue";
import NewsItem1 from "@/components/news/NewsItem1.vue";
import NewsItem4 from "@/components/news/NewsItem4.vue";

import Activity1 from "@/components/activity/Activity1.vue";
import Activity2 from "@/components/activity/Activity2.vue";
import Activity3 from "@/components/activity/Activity3.vue";
import Activity4 from "@/components/activity/Activity4.vue";
import Activity5 from "@/components/activity/Activity5.vue";

import {
  Cell,
  Field,
  Dialog,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button,
  List,
} from "vant";

Vue.use(Cell)
    .use(CellGroup)
    .use(Dialog)
    .use(Form)
    .use(Divider)
    .use(Area)
    .use(RadioGroup)
    .use(Radio)
    .use(Icon)
    .use(Toast)
    .use(Popup)
    .use(Picker)
    .use(Sidebar)
    .use(SidebarItem)
    .use(Tag)
    .use(Stepper)
    .use(Field)
    .use(Switch)
    .use(Button)
    .use(List);
export default {
  name: "QcxjClubIndex",
  components: {
    PicUploader,
    LoginDialog,

    Activity1,
    Activity2,
    Activity3,
    Activity4,
    Activity5,
    NewsItem2,
    NewsItem3,
    NewsItem1,
    NewsItem4,
  },
  data: function () {
    return {
      validator,
      kaojiShow: false,
      isLoading: false,
      showKefu: false,
      showZhibo: false,
      loading: false,
      finished: false,
      loginShow: false,
      saveLoading: false,
      showArea: false,
      sendShow: false,
      areaList: {},
      message: "",
      areaValue: "",
      submitType: "",
      item: {},
      cateList: [],
      certRow: {
        danwei: {},
        exame_center: {},
        club: {},
        club_list:[],
        center_list:[]
      },
      formData: {},
      row: {
        id: 0,
        pic: [],
        pics: [],
        list: [],
        hotel: {},
        take_list: {},
        bus_list: {},
        saiqu: {
          erweiimg_pic_url: "",
          zhibo_pic_url: "",
        },
      },

      active: 0,
      activeTab: [
        // { name: "文件", num: 0, type: -1 },
        {name: "动态", num: 0, type: 0},
        {name: "图片", num: 0, type: 1},
        {name: "视频", num: 0, type: 2}
      ],
      params: {
        id: 65,
        type: 0, // -1文件 0动态 1是图片  2是视频
        pageNo: 1,
      },
    };
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = "七彩星级、俱乐部、大课间";
    that.getCertOwn();
    that.getCateList();
    that.fetch();
  },
  watch: {},
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log("onQuestion");
    },
    getCateList() {
      let that = this;
      that.$api.get(
          "/api/cms/cateList",
          {
            parent_id: 97,
          },
          (res) => {
            that.cateList = res.data;
          },
          (res) => {
            Toast(res.msg);
          }
      );
    },
    getCertOwn() {
      let that = this;
      that.$api.post(
          "/api/user/certindexOwn",
          {},
          (res) => {
            that.certRow = res.data;
          },
          (res) => {
            console.log("errrrrr");
            if (res.code == 401 || res.code == 402) {
              if (window.isApp()) {
                rbLink(
                    {
                      name: "login",
                      query: {},
                    },
                    "replace"
                );
                return false;
              }
              that.loginShow = true;
            } else {
              Toast(res.msg);
            }
          }
      );
    },
    toClub() {
      rbLink({
        name: "ExameApplyFormBasic",
        query: {id: this.certRow.id},
      });
    },

    toKaoji() {
      this.kaojiShow = true;
    },

    // 创建考级中心/点
    toKaojiNext() {
      rbLink({
        name: "QcxjStationApplyMine",
      });
    },

    fetch() {
      let that = this;
      that.$api.get(
          "/api/activity/activity",
          that.params,
          (res) => {
            that.loading = false;

            if (res.data.list.currentpage == 1) {
              that.isLoading = false;
              that.row = res.data;
            } else {
              that.row.list.list = that.row.list.list.concat(res.data.list.list);
            }

            if (res.data.list.list.length == 0) {
              that.finished = true;
            }
            that.params.pageNo += 1;
          },
          (res) => {
            // Toast(res.msg);

            console.log("没有登录");
            if (res.code == 401 || res.code == 402) {
              if (window.isApp()) {
                rbLink(
                    {
                      name: "login",
                      query: {},
                    },
                    "replace"
                );
                return false;
              }
              that.loginShow = true;
            } else {
              Toast(res.msg);
            }
          }
      );
    },

    onClick(name, title) {
      console.log(name);
      this.params.type = this.activeTab[name].type;
      this.params.pageNo = 1;
      this.fetch();
    },
    toActivityDetail(item) {
      let that = this;
      that.$router.push({
        path: "/activity-activity-detail",
        query: {
          id: item.id,
        },
      });
    },

    onSendBox(event, item, i) {
      // console.log(event)
      this.sendShow = event.sendShow;
      this.to_comment_id = event.comment_.id;
      this.placeholder = event.comment_.user_name
          ? "@" + event.comment_.user_name
          : "说点什么...";
      (this.item = item), (this.list_index = i);
    },

    onCommentSend() {
      let that = this;
      console.log("发送评论", this.item, this.message);
      that.$api.get(
          "/api/activity/commentAdd",
          {
            topic_id: this.item.id,
            content: this.message,
            to_comment_id: this.to_comment_id
          },
          res => {
            console.log(res);
            this.row.list.list[this.list_index].comment_list.push(res.data);
            this.message = "";
          },
          res => {

            if (res.code == 401 || res.code == 402) {
              if (window.isApp()) {
                rbLink(
                    {
                      name: "login",
                      query: {}
                    },
                    "replace"
                );
                return false;
              }
              that.loginShow = true
            } else {
              Toast(res.msg);
            }
          }
      );
    },

    onRefresh() {
      let that = this;
      that.params.pageNo = 1;
      that.fetch();
    },
    onLoad() {
      // console.log(1)
      // 异步更新数据
      console.log("this.params.pageNo");
      if (this.params.pageNo > 1) {
        setTimeout(() => {
          this.fetch();
        }, 500);
      }
    },

    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.loginShow = false;
      this.getCertOwn();
      this.fetch();
    },

    loginCancel() {
      console.log("-------取消登录--------");
      // this.loginShow = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// QcxjClubIndex.vue?740cd3dc